import ContentCopy from './ContentCopy'
import { ContentFulPageProps } from '../types'
import ContentImage from './ContentImage'
import styles from './styles.module.scss'
import { ButtonLink } from '@components/ui/Button'
import classNames from 'classnames'

export default function ImageCopySectionContainerMobile({
  copy,
  copyBackgroundTransparent,
  imageMobile,
  imageDesktop,
  imageDesktopLarge,
  title,
  titleSize = 'M',
  button,
  icon
}: Pick<
  ContentFulPageProps,
  | 'copy'
  | 'copyBackgroundTransparent'
  | 'imageMobile'
  | 'imageDesktop'
  | 'imageDesktopLarge'
  | 'title'
  | 'titleSize'
  | 'button'
  | 'icon'
>) {
  const isSolidBackground = !copyBackgroundTransparent

  return (
    <>
      <ContentImage
        imageDesktop={imageDesktop}
        imageDesktopLarge={imageDesktopLarge}
        imageMobile={imageMobile}
        useGridLayout={isSolidBackground}
      />

      <div className={styles.ImageCopySectionContainer__wrapper}>
        <div className={styles.ImageCopySectionContainer__content}>
          <div className={styles.ImageCopySectionContainer__contentContainer}>
            <h2
              className={classNames(
                styles.ImageCopySectionContainer__sectionTitle,
                styles[`titleSize--${titleSize}`]
              )}
            >
              {title}
            </h2>

            <ContentCopy copy={copy.content}>
              {button && (
                <ButtonLink
                  href={button.uri}
                  variant={button.buttonStyle}
                  classes={styles.ImageCopySectionCopy__contentButton}
                >
                  {button.text}
                </ButtonLink>
              )}
              {icon && (
                <div className={styles.ImageCopySectionCopy__inlineSVG}>
                  <div
                    className={styles.svgIcon}
                    style={
                      {
                        maskImage: `url(${icon.url})`,
                        WebkitMaskImage: `url(${icon.url})`,
                        '--svgIcon-width': `${icon.width}px`,
                        '--svgIcon-height': `${icon.height}px`
                      } as React.CSSProperties
                    }
                  />
                </div>
              )}
            </ContentCopy>
          </div>
        </div>
      </div>
    </>
  )
}
